module.exports = __webpack_public_path__ + "media/images/review/ico-reviewer-status-badge-d9b5e7c22c4fc92e477c4f6be414fc04.svg";